/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { GroupedObservationType } from '../algorithm/types';

/** First, go through all the grouped observations and return:
 *  - A Record mapping the groupedObservation id to the GroupedObservationType
 *  - A Record mapping each cpt code to the list of GroupedObservations
 */
export function updateFromGroupedObservations(groupedObservations: GroupedObservationType[]) {
  const groupedObservationsById: Record<string, GroupedObservationType> = {};
  const groupedObservationIdsByCptCode: Record<string, Set<string>> = {};
  groupedObservations.forEach((groupedObservation) => {
    groupedObservationsById[groupedObservation.id] = groupedObservation;
    Object.entries(groupedObservation.cptCodes).forEach(([cptCode, data]) => {
      if (!groupedObservationIdsByCptCode[cptCode]) {
        groupedObservationIdsByCptCode[cptCode] = new Set();
      }
      groupedObservationIdsByCptCode[cptCode]!.add(groupedObservation.id);
      groupedObservation.mergeWith?.forEach((groupedObservationId) =>
        groupedObservationIdsByCptCode[cptCode]!.add(groupedObservationId)
      );
    });
  });
  return { groupedObservationsById, groupedObservationIdsByCptCode };
}
